export default __webpack_public_path__ + "media/video_play_icon.f2bb2afb.png";